<template>
  <div
    :id
    class="my-6 first:mt-0 last:mb-0"
    :class="{
      container: !parentType,
    }"
  >
    <MediaVideo v-if="media" v-bind="media" />
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphVideoFragment } from '#build/graphql-operations'

defineProps<ParagraphVideoFragment>()

const { index, siblings, parentType } = defineBlokkli({
  bundle: 'video',
  globalOptions: ['isHero', 'bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)
</script>
